import React, { useState, useEffect } from 'react'
import { func_validation } from "functions";
import 'assets/scss/components/customs/form/customMonthYearInput.scss'

export function CustomMonthYearInput(props) {

    const { 
        className, labelClassName, label, isInputRequired, isDisabled, inputClassName,
        defaultMonthYear, monthYearFromParent
    } = props;

    let label_validated = func_validation.isStringTrimNotEmpty(label) ? label : "";

    //States
    let monthYear_validated = func_validation.isNotNullUndefined(defaultMonthYear)? defaultMonthYear:"";
    const [monthYear, setMonthYear] = useState(monthYear_validated);

    function handleChange(e) {
        let newmonthYear = e.target.value
        setMonthYear(newmonthYear);

        if (func_validation.isNotNullUndefined(newmonthYear) &&
            func_validation.isFunction(props.handleOnChange))
            props.handleOnChange(newmonthYear);

        if (func_validation.isNullUndefined(newmonthYear) &&
            func_validation.isFunction(props.handleOnEmptyInput))
            props.handleOnEmptyInput();
    }

    function updateStateFromParent() {
        if (func_validation.isNotNullUndefined(monthYearFromParent)) {
            setMonthYear(monthYearFromParent);
        }
    }

    useEffect(() => {
        updateStateFromParent();
    }, [monthYearFromParent]);

    return (
        <div className={"component-monthyearpicker " +
            (className? className + " ":"")}
        >
            {/* Label */}
            {label_validated? (
                <div className={"component-monthyearpicker-labelWrapper " +
                        (labelClassName? labelClassName + " ":"")}>
                    <span className={"component-monthyearpicker-label"}>{label_validated}</span>
                    {isInputRequired? (<span className={"component-monthyearpicker-label-requiredSymbol"}>*</span>):""}
                </div>
            ):""}
            
            {/* Input */}
            <input 
                type="month" 
                className={"component-monthyearpicker-inputWrapper " +
                    (inputClassName? inputClassName + " ":"")
                }
                disabled={isDisabled} 
                value={monthYear}
                onChange={handleChange} 
            />
        </div>
    )
}